<section class="financiamiento-section">
    <div class="financiamiento-overlay"></div>
    <div class="hero-container">
        <h1 class="hero-title animate-hero-title">
            Servicios Especializados
        </h1>
    </div>
</section>

<section class="services-detail-section" #servicesSection>
    <div class="container">
        <div class="services-detail-content">

            <!-- Columna izquierda: Texto + Imagen -->
            <div class="services-left">
                <h2 class="services-intro animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
                    Servicios complementarios según las necesidades de cada empresa.
                </h2>
                <div class="services-image animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
                    <img src="/assets/Tarjetas servicios/7 Servicios Especializados.jpg" alt="Servicios Especializados">
                </div>
            </div>

            <!-- Columna derecha: Lista de servicios -->
            <div class="services-right">
                <ul class="services-list">
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Evaluación económica y financiera de proyectos de inversión.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.4s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Análisis de nuevos negocios.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.5s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Valuación de empresas.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.6s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Due Diligence financiera.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.7s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Modelos financieros.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.8s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Informes económicos sectoriales.</span>
                    </li>
                    <li class="service-item animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.9s">
                        <span class="service-icon">+</span>
                        <span class="service-text">Auditoría contable.</span>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>

<app-cta-section></app-cta-section>